import { createSlice } from '@reduxjs/toolkit';
import { calculateNetworkInterfacesAliases } from '../../lib';
import { resetApplication } from '../application/slice';
import networkInterfacesState from './state';
export const networkInterfacesSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => networkInterfacesState);
    },
    initialState: networkInterfacesState,
    name: 'networkInterfaces',
    reducers: {
        errorReceiveLockerNetworkInterfaces: state => {
            state.lockerNetworkInterfaces = undefined;
            state.requestingLockerNetworkInterfaces = false;
        },
        errorReceiveMarketNetworkInterfaces: state => {
            state.marketNetworkInterfaces = undefined;
            state.requestingMarketNetworkInterfaces = false;
        },
        errorReceiveModifyNetworkInterface: state => {
            state.requestingModifyNetworkInterface = false;
        },
        errorReceiveNetworkInterface: state => {
            state.networkInterface = undefined;
            state.requestingNetworkInterface = false;
        },
        errorReceiveOrgNetworkInterfaces: state => {
            state.orgNetworkInterfaces = undefined;
            state.requestingOrgNetworkInterfaces = false;
        },
        errorReceiveSiteNetworkInterfaces: state => {
            state.siteNetworkInterfaces = undefined;
            state.requestingSiteNetworkInterfaces = false;
        },
        failedReceiveLockerNetworkInterfaces: state => {
            state.lockerNetworkInterfaces = undefined;
            state.requestingLockerNetworkInterfaces = false;
        },
        failedReceiveMarketNetworkInterfaces: state => {
            state.marketNetworkInterfaces = undefined;
            state.requestingMarketNetworkInterfaces = false;
        },
        failedReceiveModifyNetworkInterface: state => {
            state.requestingModifyNetworkInterface = false;
        },
        failedReceiveNetworkInterface: state => {
            state.networkInterface = undefined;
            state.requestingNetworkInterface = false;
        },
        failedReceiveOrgNetworkInterfaces: state => {
            state.orgNetworkInterfaces = undefined;
            state.requestingOrgNetworkInterfaces = false;
        },
        failedReceiveSiteNetworkInterfaces: state => {
            state.siteNetworkInterfaces = undefined;
            state.requestingSiteNetworkInterfaces = false;
        },
        receiveLockerNetworkInterfaces: {
            prepare: networkInterfaces => {
                return {
                    payload: {
                        networkInterfaces
                    }
                };
            },
            reducer: (state, action) => {
                const { networkInterfaces } = action.payload;
                state.lockerNetworkInterfaces = networkInterfaces;
                state.requestingLockerNetworkInterfaces = false;
            }
        },
        receiveMarketNetworkInterfaces: {
            prepare: networkInterfaces => {
                return {
                    payload: {
                        networkInterfaces
                    }
                };
            },
            reducer: (state, action) => {
                const { networkInterfaces } = action.payload;
                state.marketNetworkInterfaces = networkInterfaces;
                state.requestingMarketNetworkInterfaces = false;
            }
        },
        receiveModifyNetworkInterface: {
            prepare: networkInterface => {
                return {
                    payload: {
                        networkInterface
                    }
                };
            },
            reducer: (state, action) => {
                const { networkInterface } = action.payload;
                state.lockerNetworkInterfaces = state.lockerNetworkInterfaces && state.lockerNetworkInterfaces.map(port => port.name === networkInterface.name ? networkInterface : port);
                state.networkInterfacesAliases = Object.assign(Object.assign({}, state.networkInterfacesAliases), { [networkInterface.name]: networkInterface.description });
                state.requestingModifyNetworkInterface = false;
            }
        },
        receiveNetworkInterface: {
            prepare: networkInterface => {
                return {
                    payload: {
                        networkInterface
                    }
                };
            },
            reducer: (state, action) => {
                const { networkInterface } = action.payload;
                state.networkInterface = networkInterface;
                state.requestingNetworkInterface = false;
            }
        },
        receiveOrgNetworkInterfaces: {
            prepare: networkInterfaces => {
                return {
                    payload: {
                        networkInterfaces
                    }
                };
            },
            reducer: (state, action) => {
                const { networkInterfaces } = action.payload;
                state.orgNetworkInterfaces = networkInterfaces;
                state.requestingOrgNetworkInterfaces = false;
            }
        },
        receiveSiteNetworkInterfaces: {
            prepare: networkInterfaces => {
                return {
                    payload: {
                        networkInterfaces
                    }
                };
            },
            reducer: (state, action) => {
                const { networkInterfaces } = action.payload;
                state.siteNetworkInterfaces = networkInterfaces;
                state.requestingSiteNetworkInterfaces = false;
            }
        },
        requestLockerNetworkInterfaces: {
            prepare: deviceId => {
                return {
                    payload: {
                        deviceId
                    }
                };
            },
            reducer: state => {
                state.requestingLockerNetworkInterfaces = true;
            }
        },
        requestMarketNetworkInterfaces: {
            prepare: edgeMarket => {
                return {
                    payload: {
                        edgeMarket
                    }
                };
            },
            reducer: state => {
                state.requestingMarketNetworkInterfaces = true;
            }
        },
        requestModifyNetworkInterface: {
            prepare: (deviceId, interfaceId, description) => {
                return {
                    payload: {
                        description,
                        deviceId,
                        interfaceId
                    }
                };
            },
            reducer: state => {
                state.requestingModifyNetworkInterface = true;
            }
        },
        requestNetworkInterface: {
            prepare: (deviceId, interfaceId) => {
                return {
                    payload: {
                        deviceId,
                        interfaceId
                    }
                };
            },
            reducer: state => {
                state.requestingNetworkInterface = true;
            }
        },
        requestOrgNetworkInterfaces: state => {
            state.requestingOrgNetworkInterfaces = true;
        },
        requestSiteNetworkInterfaces: {
            prepare: locationSlug => {
                return {
                    payload: {
                        locationSlug
                    }
                };
            },
            reducer: state => {
                state.requestingSiteNetworkInterfaces = true;
            }
        },
        resetAllNetworkInterfaces: () => networkInterfacesState,
        resetLockerNetworkInterfaces: state => {
            state.lockerNetworkInterfaces = undefined;
            state.requestingLockerNetworkInterfaces = false;
        },
        resetMarketNetworkInterfaces: state => {
            state.marketNetworkInterfaces = undefined;
            state.requestingMarketNetworkInterfaces = false;
        },
        resetNetworkInterface: state => {
            state.networkInterface = undefined;
            state.requestingNetworkInterface = false;
        },
        resetOrgNetworkInterfaces: state => {
            state.orgNetworkInterfaces = undefined;
            state.requestingOrgNetworkInterfaces = false;
        },
        resetSiteNetworkInterfaces: state => {
            state.siteNetworkInterfaces = undefined;
            state.requestingSiteNetworkInterfaces = false;
        },
        setNetworkInterfacesAliases: {
            prepare: networkInterfaces => {
                return {
                    payload: {
                        networkInterfaces
                    }
                };
            },
            reducer: (state, action) => {
                const { networkInterfaces } = action.payload;
                state.networkInterfacesAliases = calculateNetworkInterfacesAliases(networkInterfaces);
            }
        }
    }
});
export const { errorReceiveLockerNetworkInterfaces, errorReceiveMarketNetworkInterfaces, errorReceiveModifyNetworkInterface, errorReceiveNetworkInterface, errorReceiveOrgNetworkInterfaces, errorReceiveSiteNetworkInterfaces, failedReceiveLockerNetworkInterfaces, failedReceiveMarketNetworkInterfaces, failedReceiveModifyNetworkInterface, failedReceiveNetworkInterface, failedReceiveOrgNetworkInterfaces, failedReceiveSiteNetworkInterfaces, receiveLockerNetworkInterfaces, receiveMarketNetworkInterfaces, receiveModifyNetworkInterface, receiveNetworkInterface, receiveOrgNetworkInterfaces, receiveSiteNetworkInterfaces, requestLockerNetworkInterfaces, requestMarketNetworkInterfaces, requestModifyNetworkInterface, requestNetworkInterface, requestOrgNetworkInterfaces, requestSiteNetworkInterfaces, resetAllNetworkInterfaces, resetLockerNetworkInterfaces, resetMarketNetworkInterfaces, resetNetworkInterface, resetOrgNetworkInterfaces, resetSiteNetworkInterfaces, setNetworkInterfacesAliases } = networkInterfacesSlice.actions;
export default networkInterfacesSlice.reducer;
